module.exports = __webpack_public_path__ + "img/304.bbdd956c.png";